import { HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CountUpModule } from 'ngx-countup';
import { Staticks } from 'src/app/models/lookUp.model';
import { LookUpService } from 'src/app/services/lookup.service';

@Component({
    selector: 'app-funfacts',
    templateUrl: './funfacts.component.html',
})
export class FunfactsComponent implements OnInit {
    staticks: Staticks;
    constructor(private lookUpService: LookUpService,
    ) { }

    ngOnInit(): void {

        this.lookUpService.getAllStatickslist$().subscribe(x => {
            this.staticks = x
        })
    }

}